import React from 'react';
import { Box } from '@mui/material';
import { ReactComponent as IconTeam } from '@assets/svg/team.svg';
import { ReactComponent as IconActive } from '@assets/svg/active.svg';
import { ReactComponent as IconInActive } from '@assets/svg/inactive.svg';
import { CommonCard } from '@organisms';

interface CardListProps {
  totalUser: number;
  activeUser: number;
  inactiveUser: number;
}

const CardList: React.FC<CardListProps> = ({
  totalUser,
  activeUser,
  inactiveUser
}: CardListProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
        gap: 2,
        gridAutoRows: '1fr',
        mt: 2,
        mb: 3
      }}
    >
      <CommonCard title="Total Users" count={totalUser} icon={<IconTeam />} accent="neutral" />
      <CommonCard title="Active Users" count={activeUser} icon={<IconActive />} accent="success" />
      <CommonCard title="Inactive Users" count={inactiveUser} icon={<IconInActive />} accent="warning" />
    </Box>
  );
};

export default CardList;
